import { render, staticRenderFns } from "./Pastes.vue?vue&type=template&id=5907d8ca&scoped=true"
import script from "./Pastes.vue?vue&type=script&lang=js"
export * from "./Pastes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907d8ca",
  null
  
)

export default component.exports